import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h3 className="h3_head">
              Tech Stack We Use for Healthcare Application Development
            </h3>
            <p>
              Our custom healthcare app development solutions are powered by
              some of the most groundbreaking and latest technology. We have a
              team of healthcare app developers, experts in all languages and
              technologies, and create advanced software solutions.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Programming Languages">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/html5.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>HTML</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/c++.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={75}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>C++</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/javascript.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>JavaScript</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/csharp.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Csharp</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/python.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/swift.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Swift</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/java.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/vector.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kotlin</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/apple_objective.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Objective-C</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Frameworks">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/frameworks/icon_1.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Nodejs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/frameworks/icon_2.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Phonegap</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/frameworks/icon_3.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Xamarin</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/frameworks/icon_5.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Flutter</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/frameworks/icon_6.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Ionic</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            {/* <Tab eventKey="3" title="Devops">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/devops/ansible.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Ansible</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/devops/icon_2.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Terraform</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/devops/icon_3.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/devops/icon_4.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kubernetes</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/devops/icon_5.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Openshift</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/devops/icon_6.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Puppet</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/devops/icon_7.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Saltstack</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/devops/icon_8.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Sql Server</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/devops/icon_9.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Chef</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Payment Gateways">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/gateways/stripe.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Stripe</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/gateways/paypal.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Paypal</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/gateways/square.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Square</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/gateways/adyen.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Adyen</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/gateways/alipay.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Alipay</h6>
                  </div>
                </li>
              </ul>
            </Tab> */}
            <Tab eventKey="5" title="Cloud">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/cloud/aws.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/cloud/azure.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/cloud/google_cloud.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
